export default {
    pagination: {
        pageNum: 1,
        pageSize: 50,
        total: 0,
        paginationkey: 0
    },
    formlist: [
        {
            prop: 'sobName',
            label: '软件名称',
            type: 'input',
            width: '150px'
        },
        {
            prop: 'sobName',
            label: '著作权登记日期',
            width: '150px',
            type: "datemonth",
            valueformat: 'yyyyMM'
        },
         {
            prop: 'bsType',
            label: '即征即退有效期',
            type: "datetimerange",
            valueformat:'yyyy-MM-dd',
            width: '150px'
        },
        {
            prop: 'sobName',
            label: '著作权编号',
            type: 'input',
            width: '150px'
        },
        {
            prop: 'sobName',
            label: '备案时间',
            width: '150px',
            type: "datemonth",
            valueformat: 'yyyyMM'
        },
    ],
    formdata: {
        SobName: '',
        bsType: ''
    }
};
